"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
/* eslint-disable import/no-extraneous-dependencies */
/* eslint-disable @typescript-eslint/no-unused-vars */
const react_1 = require("react");
const react_router_dom_1 = require("react-router-dom");
const sdk_1 = __importDefault(require("@twa-dev/sdk"));
const ton_1 = require("ton");
const de_ui_1 = require("@delab-team/de-ui");
// eslint-disable-next-line import/no-extraneous-dependencies
const qr_scanner_1 = __importDefault(require("qr-scanner"));
const react_i18next_1 = require("react-i18next");
const tonapi_1 = require("../../logic/tonapi");
const qr_module_css_1 = __importDefault(require("./qr.module.css"));
const titleTgStyles = { color: 'var(--tg-theme-text-color)' };
const TonConnectQRPage = (props) => {
    const { t } = (0, react_i18next_1.useTranslation)();
    const location = (0, react_router_dom_1.useLocation)();
    const navigate = (0, react_router_dom_1.useNavigate)();
    const TgObj = sdk_1.default;
    const [value, setValue] = (0, react_1.useState)('');
    const videoRef = (0, react_1.useRef)(null);
    const fileInputRef = (0, react_1.useRef)(null);
    const [qrVal, setQrVal] = (0, react_1.useState)('');
    const tonapi = new tonapi_1.TonApi();
    (0, react_1.useEffect)(() => {
        const initializeScanner = async () => {
            const videoElement = videoRef.current;
            if (!videoElement) {
                return;
            }
            try {
                const scanner = new qr_scanner_1.default(videoElement, (result) => {
                    try {
                        console.log('QR result', result);
                        if (result.startsWith('tc://')) {
                            const res = result.replace('tc://', '');
                            console.log('res with replace', res);
                            const urlSearch = new URLSearchParams(res);
                            console.log('tc:// case');
                            console.log('urlSearch QR', urlSearch);
                            console.log('urlSearch.get(id)', urlSearch.get('id'));
                            console.log('urlSearch.get(v)', urlSearch.get('v'));
                            const id = urlSearch.get('id');
                            const v = urlSearch.get('v');
                            const r = urlSearch.get('r');
                            // const ret = urlSearch.get('ret')
                            console.log('id', id);
                            console.log('r', r);
                            if (id && v && r) {
                                props.setUrlTonConnectQRQuerry({
                                    v,
                                    r,
                                    id
                                });
                                console.log('after setUrlTonConnectQRQuerry', props.urlTonConnectQRQuerry);
                                TgObj.BackButton.hide();
                                navigate('/');
                            }
                        }
                        if (result.startsWith('https://')) {
                            const urlSearch = new URLSearchParams(new URL(result).search);
                            console.log('urlSearch QR', urlSearch);
                            const id = urlSearch.get('id');
                            const v = urlSearch.get('v');
                            const r = urlSearch.get('r');
                            // const ret = urlSearch.get('ret')
                            if (id && v && r) {
                                props.setUrlTonConnectQRQuerry({
                                    v,
                                    r,
                                    id
                                });
                                console.log('after setUrlTonConnectQRQuerry', props.urlTonConnectQRQuerry);
                                TgObj.BackButton.hide();
                                navigate('/');
                            }
                        }
                        if (result.startsWith('ton://transfer/')) {
                            const resultLink = result.replace('ton://transfer/', '');
                            props.setSendData({ ...props.sendData, sendAddress: ton_1.Address.parse(resultLink).toString({ bounceable: false }) });
                            props.setShowSendModal(true);
                            props.setSkipUserAddress(true);
                            navigate('/');
                        }
                    }
                    catch (error) {
                        console.log(error);
                    }
                });
                scanner.start();
                // eslint-disable-next-line consistent-return
                return () => {
                    scanner.stop();
                };
            }
            catch (error) {
                console.error('Error initializing QR scanner:', error);
            }
        };
        initializeScanner();
    }, []);
    // const checkCamera = async () => {
    //     const hasCamera = await QrScanner.hasCamera()
    //     if (!hasCamera) {
    //         alert(t('send.send-to-position.no-camera-found'))
    //         return false
    //     }
    //     return true
    // }
    // useEffect(() => {
    //     const res = checkCamera()
    //     console.log('HAS CAMERA', res)
    // }, [])
    // useEffect(() => {
    //     if (qrVal.startsWith('tc://?')) {
    //         const res = qrVal.replace('tc://?', '')
    //         console.log('tc://? case')
    //         const urlSearch = new URLSearchParams(res)
    //         console.log('urlSearch QR', urlSearch)
    //         console.log('urlSearch.get(id)', urlSearch.get('id'))
    //         console.log('urlSearch.get(v)', urlSearch.get('v'))
    //         const id = urlSearch.get('id')
    //         const v = urlSearch.get('v')
    //         const r = urlSearch.get('r')
    //         // const ret = urlSearch.get('ret')
    //         console.log('id', id)
    //         console.log('r', r)
    //         if (id && v && r) {
    //             props.setUrlTonConnectQRQuerry({
    //                 v,
    //                 r,
    //                 id
    //             })
    //             console.log('after setUrlTonConnectQRQuerry', props.urlTonConnectQRQuerry)
    //             TgObj.BackButton.hide()
    //             navigate('/')
    //         }
    //     }
    //     if (qrVal.startsWith('https://')) {
    //         const urlSearch = new URLSearchParams(new URL(qrVal).search)
    //         console.log('urlSearch QR', urlSearch)
    //         const id = urlSearch.get('id')
    //         const v = urlSearch.get('v')
    //         const r = urlSearch.get('r')
    //         // const ret = urlSearch.get('ret')
    //         if (id && v && r) {
    //             props.setUrlTonConnectQRQuerry({
    //                 v,
    //                 r,
    //                 id
    //             })
    //             console.log('after setUrlTonConnectQRQuerry', props.urlTonConnectQRQuerry)
    //             TgObj.BackButton.hide()
    //             navigate('/')
    //         }
    //     }
    //     if (qrVal.startsWith('ton://transfer/')) {
    //         const resultLink = qrVal.replace('ton://transfer/', '') as string
    //         props.setSendData({ ...props.sendData, sendAddress: resultLink })
    //         props.setShowSendModal(true)
    //         props.setSkipUserAddress(true)
    //         navigate('/')
    //     }
    // }, [ qrVal ])
    // const SetAddres = async (value: string) => {
    //     if (value) {
    //         try {
    //             if (value.endsWith('.ton') || value.endsWith('.t.me')) {
    //                 const res = await tonapi.getAddressByDomainName(value)
    //                 if (!res || res?.wallet.address.length === 0) {
    //                     return
    //                 }
    //                 const addr = Address.parse(res?.wallet.address)
    //                 props.setSendData({
    //                     ...props.sendData,
    //                     sendAddress: addr as any
    //                 })
    //             } else {
    //                 if (!AddrCheck.isValid(value)) {
    //                     return
    //                 }
    //                 // const addr = Address.parse(value)
    //                 props.setSendData({
    //                     ...props.sendData,
    //                     sendAddress: value
    //                 })
    //             }
    //         } catch (err) {
    //             console.error(err)
    //         }
    //     }
    // }
    // useEffect(() => {
    //     SetAddres(value)
    // }, [ value ])
    function enableBackBtn() {
        TgObj.BackButton.show();
    }
    (0, react_1.useEffect)(() => {
        enableBackBtn();
        const closeQr = () => {
            TgObj.HapticFeedback.impactOccurred('medium');
            props.setUrlTonConnectQRQuerry(undefined);
            TgObj.BackButton.hide();
            navigate('/');
        };
        TgObj.BackButton.onClick(closeQr);
        return () => {
            TgObj.BackButton.offClick(closeQr);
        };
    }, []);
    // const handleFileChange = (event) => {
    //     const file = event.target.files[0]
    //     if (file) {
    //         const reader = new FileReader()
    //         reader.onload = (e) => {
    //             const qr = new QrCode()
    //             qr.callback = (err, value) => {
    //                 if (err) {
    //                     console.error(err)
    //                 } else {
    //                     let res = value.result
    //                     if (res.startsWith('ton://transfer/')) {
    //                         res = res.replace('ton://transfer/', '')
    //                     }
    //                     setValue(res)
    //                 }
    //             }
    //             qr.decode(reader.result)
    //         }
    //         reader.readAsDataURL(file)
    //     }
    // }
    return ((0, jsx_runtime_1.jsx)("div", { className: qr_module_css_1.default.container, children: (0, jsx_runtime_1.jsx)("div", { className: qr_module_css_1.default.qrContent, children: (0, jsx_runtime_1.jsxs)("div", { className: qr_module_css_1.default.qr, children: [(0, jsx_runtime_1.jsx)("video", { className: qr_module_css_1.default.qrCamera, ref: videoRef, autoPlay: true, playsInline: true }), (0, jsx_runtime_1.jsx)("div", { className: qr_module_css_1.default.qrBack, children: (0, jsx_runtime_1.jsx)("div", { className: qr_module_css_1.default.qrArea, children: (0, jsx_runtime_1.jsx)(de_ui_1.Title, { className: qr_module_css_1.default.scanText, variant: 'h5', children: "Scan your QR code" }) }) })] }) }) }));
};
// eslint-disable-next-line import/no-default-export
exports.default = TonConnectQRPage;
